import React
	from 'react';
import ReactDOM
	from 'react-dom';
import './styles/index.css';
import App
	from './App';
import reportWebVitals
	from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.css"
import 'react-languages-select/css/react-languages-select.css';

ReactDOM.render(
		<App />,
		document.getElementById('root')
);
reportWebVitals();
